import { useSelector } from 'react-redux';
import { DeepLinkSearchParams } from '@server/deep-link-search-params';
import useQueryParams from '../../../navigation-utils/useQueryParams';
import { selectMetadataTypesList } from '../../../reducers/documentation/metadataReducer';
import { useRunOnceWhenTruthy } from '../../common/useRunOnceWhenTruthy';
import { SalesforceItem } from '../../parser/ParserTypes';
import { buildConfigurationItemId } from '../salesforce-documentation-card/helpers';
import {
  DocumentationCardContentViewType,
  DocumentationCardItem,
} from '../salesforce-documentation-card/types';

export function useMetadataHandleDeepLink({
  elements,
  handleSetConfigurationItem,
  crmOrgId,
}: {
  elements: SalesforceItem[];
  handleSetConfigurationItem: (props: DocumentationCardItem) => void;
  crmOrgId: string;
}) {
  const queryParams = useQueryParams();
  const elementsLoaded = useSelector(selectMetadataTypesList(crmOrgId));

  useRunOnceWhenTruthy(() => {
    const configurationItemId = queryParams.get(DeepLinkSearchParams.configurationItemId);
    if (configurationItemId) {
      const item = elements.find(
        (element) => buildConfigurationItemId(element) === configurationItemId,
      );
      if (item) {
        handleSetConfigurationItem({
          item,
          clearHistory: true,
          contentType: DocumentationCardContentViewType.default,
        });
      }
    }
  }, Boolean(elementsLoaded));
}
